
  import Vue from "vue";
  import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
  import General from "../../components/dailyReportTabs/General.vue";
  import MudProperties from "@/components/dailyReportTabs/mudProperties.vue";
  import BudgetSheet from "@/components/BudgetSheet";
  import ReportBudgetSheet from "@/components/ReportBudgetSheet.vue"
  import LumpSumBudgetSheet from "@/components/LumpSumBudgetSheet.vue"
  import projectCostBudgetSheet from "@/components/dailyReportTabs/projectCostBudgetSheet.vue"
  import DailyReporViewer from "./DailyReport/DailyReportViewer";
  import { HTTP } from "@/axios_api/http-common";
  import MudVolume from "../../components/dailyReportTabs/mudVolume.vue";
  import MudLosses from "@/components/dailyReportTabs/mudLosses.vue";
  import PersonnelContact from "@/components/dailyReportTabs/personnelContact.vue";
  import TimeBreakDown from "@/components/dailyReportTabs/timeBreakDown.vue";
  import Safety from "@/components/dailyReportTabs/safety.vue";
  import Bits from "@/components/dailyReportTabs/bits.vue";
  import DrillingParameters from "@/components/dailyReportTabs/drillingParameters.vue";
  import AFE from '@/components/dailyReportTabs/AFEsummary.vue'
  import depthSummary from '@/components/dailyReportTabs/depthSummary.vue'
  import DeviationSurveyImport from "@/components/DeviationSurveyImport.vue"
  import convertUnit from '@/utils/convertUnit';
  import UserProvisioning from "@/mixins/userProvisioning";
  
  var currentDate = new Date(Date.now());
  
  @Component({
    components: {
      "budget-sheet": BudgetSheet,
      "report-budget-sheet": ReportBudgetSheet,
      "lump-sum-budget-sheet": LumpSumBudgetSheet,
      "project-cost-budget-sheet": projectCostBudgetSheet,
      "report-viewer": DailyReporViewer,
      "deviation-import": DeviationSurveyImport,
      general: General,
      "mud-properties": MudProperties,
      "mud-volume": MudVolume,
      "mud-losses": MudLosses,
      "personnel-contact": PersonnelContact,
      "time-break-down": TimeBreakDown,
      safety: Safety,
      bits: Bits,
      DrillingParameters,
      'afe-summary': AFE,
      depthSummary
    },
  })
  export default class ReportSheet extends Mixins(UserProvisioning) {
    @Prop({ default: -1 })
    projectId!: any;
    @Prop({default:false}) isEditingDailyReport!:boolean;
    @Prop({}) editedReport!:any;
    @Prop({default: false}) isEdit!:any;
    @Prop({default: []}) departments!:any;
  
    busy: string = "NONE";
    bit = 0;
    mud = 0;
    cost = 0;
    showDeviationSurveyImportModel=false
  
    get selectedProject() {
      return this.$store.getters["projectModule/getProjectById"](this.projectId);
    }
   
    activityLogFields: Array<any> = [
      {
        key: "from",
        label: "Start",
      },
      {
        key: "to",
        label: "End",
      },
      {
        key: "depth",
        label: "Depth (ft)",
      },
      "activity",
      "milestone",
      "description",
      {
        key: "hasNpt",
        label: "NPT ?",
      },
      {
        key: "nptCategory",
        label: "NPT Category",
      },
      {
        key: "rootCause",
        label: "Root Cause",
      },
      {
        key: "contractor",
        label: "Contractor",
      },
      {
        key: "service",
        label: "Service",
      },
      {
        key: "nptHours",
        label: "NPT Hours",
      },
      {
        key: "nptDescription",
        label: "NPT Description",
      },
      {
        key: "actions",
        label: "",
      },
    ];
    personnelFields: Array<any> = [
      { key: "contactName", label: "Name" },
      { key: "position", label: "Position" },
      { key: "email", label: "Email" },
      { key: "mobile", label: "Mobile" },
      { key: "company", label: "Company" },
      { key: "office", label: "Office Ext." },
      { key: "button", label: "Action" },
    ];
    personnelOnBoardFields: Array<any> = [
      { key: "company", label: "Company" },
      { key: "serviceType", label: "Service Type" },
      { key: "workHour", label: "Work Hours" },
      { key: "standByHour", label: "Stand-By Hours" },
      { key: "count", label: "Count" },
      { key: "note", label: "Notes" },
      { key: "button", label: "Action" },
    ];
    deviationFields: Array<any> = [
      { key: "index", label: "Seq. No." },
      { key: "mD", label: "MD" },
      { key: "inclinationAngle", label: "Inclination (deg)" },
      { key: "azimuth", label: "Azimuth (deg)" },
      { key: "tVD", label: "TVD" },
      { key: "verticalSection", label: "Vertical Section" },
      { key: "nS", label: "+N/S-" },
      { key: "eW", label: "+E/W-" },
      { key: "dLS", label: "DLS("+String.fromCharCode(176)+"/100ft)" },
      { key: "button", label: "Action" },
    ];
    incidentField: Array<any> = [
      { key: "date", label: "Date" },
      { key: "time", label: "Time" },
      { key: "reporterName", label: "Reporter's Name" },
      { key: "numMinorInjury", label: "Minor Injuries" },
      { key: "numMajorInjury", label: "Major Injuries" },
      { key: "numOfDeath", label: "Persons Killed" },
      { key: "isNearMiss", label: "Near Miss?" },
      { key: "descLocation", label: "Location Description" },
      { key: "descAccident", label: "Accident Description" },
      { key: "remedialActionDesc", label: "Remedial Action Description" },
      { key: "causeDesc", label: "Cause Description" },
      { key: "eTimLostGross", label: "Lost Hours" },
      { key: "costLossGross", label: "Gross Cost Estimate" },
      { key: "responsibleCompany", label: "Responsible Company" },
      { key: "button", label: "Actions" },
    ];
    lineSum = 0
    activeView = "General"
    views = [
      'General',
      'Activity Logs',
      'Cost and AFE Summary',
      'Bits and Depths Summary',
      'Drilling Parameters',
      'Mud Properties',
      'Times Breakdown',
      'Deviation Survey',
      'Safety',
      'Personnels',
      'Personnel On Board'
    ];
    costingOptions: Array<any> = [
      { text: 'Use Line Item Cost', value: 'LineItem' },
      { text: 'Use Lump Sum Cost', value: 'LumpCost' },
      { text: 'Use Total Cost', value: 'TotalCost' },
    ]
    rootCauseOptions: Array<any> = []
    servicesOptions: Array<any> = []
    activityLog = [] as Array<any>;
    showViewer = false
    force = 0;
    dailyReport = {
      activityLog: [] as Array<any>,
      id:0,
      startDepth: "0",
      endDepth: "0",
      depthReference: 0,
      depthReferenceType: "",
      dailySummary: "",
      currentStatus: "",
      dailyForecast: "",
      dailyChallenge: "",
      // costOption: 'LineItem',
      reportDate: currentDate,
      startTime: "06:00",
      endTime: "06:00",
      unitSystem: this.currentUnitSystem || "",
      selectedViews: ['General', 'Activity Logs', 'Cost and AFE Summary'],
      budgetChanged: false,
      dailyTotalCost: 0,
      cost: { budgetTemplateId: "", budgetLines: [] },
      projectCost: { budgetTemplateId: "", budgetLines: [] },
      lumpedCosts: [],
      targets: [],
      mud: {
        mudType: "",
        mudWeight: "0",
        funnelViscosity: "0",
        eCD: "0",
        plasticViscosity: "0",
        yieldPoint: "0",
        gelStrength: "0",
        pitTemp: "0",
        hTHP: "0",
        cake: "0",
        solids: "0",
        dailyMudCost: "0",
        prevMudCost: "0",
        totalMudCost: "0",
      },
      mudVolume: {
        volTotMudStart: "0",
        volMudDumped: "0",
        volMudReceived: "0",
        volMudReturned: "0",
        volMudBuilt: "0",
        volMudString: "0",
        volMudCasing: "0",
        volMudHole: "0",
        volMudRiser: "0",
      },
      depthSummaryModel: {
        currentHoleSize: "0",
        currentDepth: "0",
        totalDepth: "0",
        actualTotalDepth: "0",
        previousDepth: "0",
        depthProgress: "0",
        casingType: "Conductor",
        casingSize: "0",
        casingDepth: "0",
        topOfLiner: "0",
        lot: this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.lot : "0",
        fit: this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.fit : "0",
      },
      scheduleModel: {
        plannedRigMoveStartDate: null,
        plannedRigMoveEndDate: null,
        plannedRigMoveDays: 0,
        plannedOperationsDays: 0,
        actualRigMoveDays: 0,
        rigMoveStartDate: null,
        rigMoveEndDate: null,
        spudDate: null,
        spudTime: "06:00",
        daysOnLocation: "0",
        daysFromSpud: 0,
        operatingDaysVariance: 0
      },
      aFESummaryModel: {
        code: '',
        supplementaryCode: '',
        amount: "0",
        supplementaryAmount: "0",
        actualBudgetRatio: "0",
        supplementaryBudgetRatio: "0",
        dailyCost: 0,
        cummulativeCost: "0",
        percentage: "0",
        suppPercentage: "0",
        isAmount: false
      },
      mudLosses: {
        volLostShakerSurf: "0",
        volLostMudCleanerSurf: "0",
        volLostPitsSurf: "0",
        volLostTrippingSurf: "0",
        volLostOtherSurf: "0",
        volLostCircHole: "0",
        volLostCsgHole: "0",
        volLostCmtHole: "0",
        volLostBhdCsgHole: "0",
        volLostAbandonHole: "0",
        volLostOtherHole: "0",
      },
      personnelContactsLog: [] as Array<any>,
      timeBreakDown: {
        circulation: "0",
        rIH: "0",
        pOOH: "0",
        drilling: "0",
        cementing: "0",
        tCP: "0",
        others: "0",
      },
      safetyModel: {
        lastBOPDrill: null,
        nextBOPTest: null,
        lastSafetyMeeting: null,
        lastFireDrill: null,
        lastBOPTest: null,
        lastCsgPres: null,
      },
      bitModel: {
        bha: "0",
        bitSize: "0",
        modelNo: '',
        bitType: '',
        iadcNo: "0",
        serialNo: "0",
        bitHours: "0",
        bitNozzless: "0",
        tfa: "0",
        impact: "0",
        jetVelocity: "0",
        rop: "0",
        rpm: "0",
        bitRevolution: "0",
        bitRotationHours: "0",
        averageCummulative: "0",
        wob: "0",
        footage: "0"
      },
      deviationSurveyData: [] as Array<any>,
      drillingParametersModel: {
        torque: "0",
        depth: "0",
        puWeight: "0",
        soWeight: "0",
        maxOPull: "0",
        rotatingWeight: "0",
      },
      personnelOnBoardLog: [] as Array<any>
    } as any;
  
    get filteredMilestones(): any {
      return this.dailyReport.activityLog.map((a: any) => a.milestone);
    }
  
    get activitiesForProject(){
      return this.$store.getters["ActivityModule/getNewActivitiesForProject"](this.projectId)
    }
    get rigMove() {
      return this.activitiesForProject.find((x: any) => x.wellActivity.id === '3')
    }
    get drilling() {
      return this.activitiesForProject.find((x: any) => x.wellActivity.id === '1')
    }
    get completion() {
      return this.activitiesForProject.find((x: any) => x.wellActivity.id === '2')
    }
    get activityOptions(): any {
      return this.activitiesForProject.map((thisActivity: any) => ({
        text: thisActivity.wellActivity.name,
        value: thisActivity,
      }));
    }
    
    currentDepthChange() {
      this.dailyReport.depthSummaryModel.currentDepth = this.dailyReport.endDepth;
      this.dailyReport.depthSummaryModel.depthProgress = this.dailyReport.depthSummaryModel.currentDepth - this.dailyReport.depthSummaryModel.previousDepth;
      this.dailyReport.depthSummaryModel.actualTotalDepth = this.dailyReport.depthSummaryModel.currentDepth;
      this.dailyReport.depthSummaryModel.totalDepth = this.selectedProject.well && this.selectedProject.well.totalDepthMD ? this.selectedProject.well.totalDepthMD.value : "0";
    }
  
    plannedRigDays() {
      this.dailyReport.scheduleModel.plannedRigMoveDays = !this.dailyReport.scheduleModel.plannedRigMoveStartDate|| !this.dailyReport.scheduleModel.plannedRigMoveEndDate?1:this.getDaysDifference(this.dailyReport.scheduleModel.plannedRigMoveStartDate, this.dailyReport.scheduleModel.plannedRigMoveEndDate)
    }
    actualRigDays() {
      this.dailyReport.scheduleModel.actualRigMoveDays = !this.dailyReport.scheduleModel.rigMoveStartDate || !this.dailyReport.scheduleModel.rigMoveEndDate?1:this.getDaysDifference(this.dailyReport.scheduleModel.rigMoveStartDate, this.dailyReport.scheduleModel.rigMoveEndDate)
    }
    addDays() {
      const date = new Date(this.dailyReport.scheduleModel.rigMoveStartDate)
      this.dailyReport.scheduleModel.rigMoveEndDate = new Date(date.setDate(date.getDate() + Number(this.dailyReport.scheduleModel.actualRigMoveDays - 1)))
    }
    
    get departmentsForSequence(): any {
      if (this.selectedProject.departmentBudgets && this.selectedProject.departmentBudgets.length) {
        const deptIds = this.selectedProject.departmentBudgets.map((d:any) => d.departmentId);
        const departments = this.getDepartmentOptions.filter((d:any) => deptIds.includes(d.id));
        return departments;
      }
      return [];
    }
    
    get getPlanBudgetForProject(){
      let totalBudget = 0
      if (this.selectedProject.costOption === 'LineItem') {
        this.activitiesForProject.forEach((activity:any) => {
          if(activity.budget){
            activity.budget.budgetLines.forEach((budgetLine:any) => {
              totalBudget += budgetLine.lineValue
            })
          }
        });
      }
      else if (this.selectedProject.costOption === 'LumpCost') {
        if (this.selectedProject.departmentBudgets && this.selectedProject.departmentBudgets.length) {
          this.selectedProject.departmentBudgets.forEach((d:any) => {
            totalBudget += d.approvedBudget
          });
        }
      }
      else if (this.selectedProject.costOption === 'DailyCost') {
        totalBudget = this.selectedProject.approvedAFEBudget;
      }
      else if (this.selectedProject.costOption === 'ProjectCost') {
        if(this.selectedProject.approvedBudget && this.selectedProject.approvedBudget !== null){
            this.selectedProject.approvedBudget.budgetLines.forEach((budgetLine:any) => {
              totalBudget += budgetLine.lineValue
            })
          }
      }
      return totalBudget
    }
    
    get showCostForm(): any {
      if (this.dailyReport.activityLog.length < 1) {
        return false;
      }
      else if (this.selectedProject.costOption === 'ProjectCost' && this.selectedProject.approvedBudget === null) {
        return false;
      }else {
        // if (this.dailyReport.activityLog[0].activity.budget == null || ) return false;
        return true;
      }
    }
  
    get nptOptions(): any {
      const uniqueOperations = new Set();
      return this.nptSettings
        .filter((n: any) => {
          if (uniqueOperations.has(n.nptCategory)) {
            return false; 
          }
          uniqueOperations.add(n.nptCategory);
          return true;
        })
        .map((n: any) => ({
          text: n.nptCategory,
          value: n.nptCategory,
        })
      );
    }

    // getSelectedNpt(item: any) { 
    //   window.console.log(item)
    //   const operations = this.nptSettings.find((n: any) => n.nptCategory === item.nptCategory);
    //   this.rootCauseOptions = operations.rootCauses
    //     .map((n: any) => ({
    //       text: n,
    //       value: n,
    //     })
    //   );
    // }

    get causes() {
      return (item: any) => {
        const operations = this.nptSettings.find((n: any) => n.nptCategory === item.nptCategory);
        if (operations) {
          return operations.rootCauses
            .map((n: any) => ({
              text: n,
              value: n,
            })
          );
        }
        return []
      }
    }

    get contractorOptions(): any {
       return this.contractorAndServicesOptions.map((n: any) => n.contractor) 
    }

    getContractorServices(item: any) {
      // item.service = null
      this.servicesOptions = this.contractorAndServicesOptions.find((n:any) => n.contractor === item.contractor).services
        .map((service: any) => ({
          text: service,
          value: service
        })
      )
    }

    get canSaveReport(){
      let result = true;
      if(this.dailyReport.activityLog.length>0){      
        this.dailyReport.activityLog.forEach((logEntry:any) => {
        if(logEntry.nptOperation != undefined){
          if(logEntry.hasNpt && (logEntry.nptCategory == undefined || logEntry.nptCategory == "")){
              return result = false;
          }
          }
          if(logEntry.activity == null )
          {
              return result = false;
          }
        });
      }
      return result;
    }

    getSelectedActivity(activityLog:any) {
      if (activityLog.activity.start === null || activityLog.activity.end === null) {
          activityLog.from = "";
          activityLog.to = "";
          this.force ++;
      }
    }

    downloadDeviationSurvey(){
      HTTP.get('ddr/export/deviationsurvey/?dailyReportId=' + this.dailyReport.id, { responseType: "blob" })
        .then((res: any) => {
          var blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          const link = document.createElement("a");
          const downloadUrl = window.URL.createObjectURL(blob);
          link.href = downloadUrl;
          link.setAttribute("download", res.headers.filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error: any) => {});
      }

      downloadDeviationSurveySheet(){
        HTTP.get('ddr/import-template', { responseType: "blob" })
          .then((response: any) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(
              new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              })
            );
            link.setAttribute('download', 'Deviation Survey Import Template' + '.' + 'xlsx');

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // resolve(response)
          })
          .catch((error: any) => {});
        }
        
    addRow() {
      const log = this.dailyReport.activityLog;
      this.dailyReport.activityLog.push({
        id:0,
        from: log[log.length - 1] ? log[log.length - 1].to : "00:00",
        to: "00:00",
        milestone: null,
        activity: null,
        description: "",
        depth: 0,
        hasNpt: false,
        nptHours:0,
        nptDescription:"",
        nptOperation: {
          name: "",
          nptCategory:  "",
          rootCause:  "",
          associatedCause:  "",
          id:"",
         },
      });
    }
  
    addPersonnel() {
      this.dailyReport.personnelContactsLog.push({
        id:0,
        contactName: "",
        email: "",
        mobile: "",
        company: "",
        position: "",
        office: "",
      });
    }
  
    addDeviationSurvey() {
      this.dailyReport.deviationSurveyData.push({
        mD: 0,
        inclinationAngle: 0,
        azimuth: 0,
        tVD: 0,
        verticalSection: 0,
        nS: 0,
        eW: 0,
        dLS: 0
      });
    }

    handleDeviationImported(deviationSurveys: Array<any>) {
      deviationSurveys.forEach((data:any) => {
        this.dailyReport.deviationSurveyData.push({
          mD: data.md,
          inclinationAngle: data.inclinationAngle,
          azimuth: data.azimuth,
          tVD: data.tvd,
          verticalSection: data.verticalSection,
          nS: data.ns,
          eW: data.ew,
          dLS: data.dls
        });
      })
    }

    calculateAfeCummulativeCost(reportDate: string) {
      const reportDateObj = new Date(reportDate);
      const filteredDdrs = this.ddrs.filter(ddr => new Date(ddr.reportDate) < reportDateObj);
      const sortedReport = filteredDdrs.sort((a:any, b:any) => {
        const dateA = new Date(a.reportDate);
        const dateB = new Date(b.reportDate);
        return dateA.getTime() - dateB.getTime();
      });
      const allReportByActivity = sortedReport.flatMap((report: any) => {
        if (report && report.cost && report.cost.budgetLines && report.cost.budgetLines.length && this.selectedProject.costOption === 'LineItem') {
          return report.cost.budgetLines.reduce((a: any, b: any) => a + (b['lineValue'] || 0), 0);
        }
        else if (report && report.lumpedCosts && report.lumpedCosts.length && this.selectedProject.costOption === 'LumpCost') {
          return report.lumpedCosts.reduce((a: any, b: any) => a + (b['lineValue'] || 0), 0);
        }
        else if (report && report.dailyTotalCost && report.dailyTotalCost > 0 && this.selectedProject.costOption === 'DailyCost') {
          return report.dailyTotalCost;
        }
        else if (report && report.projectCost && report.projectCost.budgetLines && report.projectCost.budgetLines.length > 0 && this.selectedProject.costOption === 'ProjectCost') {
          return report.projectCost.budgetLines.reduce((a: any, b: any) => a + (b['lineValue'] || 0), 0);
        }
        // if (report.afeSummary && report.afeSummary.dailyCost) {
        //   return report.afeSummary.dailyCost;
        // } 
        return [];
      });
      return allReportByActivity.reduce((sum, value) => sum + value, 0);
    }

    @Watch('dailyReport', {immediate:true,deep:true})
    OnReportChanged(a: any,b: any) {
      if (this.dailyReport && this.dailyReport.cost && this.dailyReport.cost.budgetLines && this.selectedProject.costOption === 'LineItem') {
          let sum = this.dailyReport.cost.budgetLines.reduce((a: any, b: any) => a + (b['lineValue'] || 0), 0);
          this.lineSum = sum
          if (this.dailyReport.aFESummaryModel) {
            this.dailyReport.aFESummaryModel.dailyCost = sum
            this.dailyReport.aFESummaryModel.cummulativeCost = this.calculateAfeCummulativeCost(this.dailyReport.reportDate) > 0 ? this.calculateAfeCummulativeCost(this.dailyReport.reportDate) + sum : sum
          }
      }
      else if (this.dailyReport && this.dailyReport.lumpedCosts && this.selectedProject.costOption === 'LumpCost') {
        let sum = this.dailyReport.lumpedCosts.reduce((a: any, b: any) => a + (b['lineValue'] || 0), 0);
        this.lineSum = sum
        if (this.dailyReport.aFESummaryModel) {
          this.dailyReport.aFESummaryModel.dailyCost = sum
          this.dailyReport.aFESummaryModel.cummulativeCost = this.calculateAfeCummulativeCost(this.dailyReport.reportDate) > 0 ? this.calculateAfeCummulativeCost(this.dailyReport.reportDate) + sum : sum
        }
      }
      else if (this.dailyReport && this.dailyReport.dailyTotalCost && this.selectedProject.costOption === 'DailyCost') {
        let sum = this.dailyReport.dailyTotalCost;
        this.lineSum = sum
        if (this.dailyReport.aFESummaryModel) {
          this.dailyReport.aFESummaryModel.dailyCost = sum
          this.dailyReport.aFESummaryModel.cummulativeCost = this.calculateAfeCummulativeCost(this.dailyReport.reportDate) > 0 ? this.calculateAfeCummulativeCost(this.dailyReport.reportDate) + sum : sum
        }
      }
      else {
          let sum = this.dailyReport.projectCost.budgetLines.reduce((a: any, b: any) => a + (b['lineValue'] || 0), 0);
          this.lineSum = sum
          if (this.dailyReport.aFESummaryModel) {
            this.dailyReport.aFESummaryModel.dailyCost = sum
            this.dailyReport.aFESummaryModel.cummulativeCost = this.calculateAfeCummulativeCost(this.dailyReport.reportDate) > 0 ? this.calculateAfeCummulativeCost(this.dailyReport.reportDate) + sum : sum
          }
      }
    }
  
    addPersonnelOnBoard() {
      this.dailyReport.personnelOnBoardLog.push({
        id:0,
        company : "",
        serviceType: "",
        workHour: "",
        standByHour: "",
        count: 0,
        note: '',
      });
    }
    removePersonnel(index: number) {
      this.dailyReport.personnelContactsLog.splice(index, 1);
    }
    removePersonnelOnBoard(index: number) {
      this.dailyReport.personnelOnBoardLog.splice(index, 1);
    }
    removeDeviationSurvey(index: number) {
      this.dailyReport.deviationSurveyData.splice(index, 1);
    }
    reInitDailyReport() {
      this.dailyReport = {
        id:0,
        activityLog: [] as Array<any>,
        startDepth: "0",
        endDepth: "0",
        reportDate: currentDate,
        startTime: "06:00",
        endTime: "06:00",
        unitSystem: this.currentUnitSystem || "",
        selectedViews: ['General', 'Activity Logs', 'Cost and AFE Summary'],
        budgetChanged: false,
        depthReference: this.lastDdr && this.lastDdr.depthReference ? this.lastDdr.depthReference : "0",
        depthReferenceType: this.lastDdr && this.lastDdr.depthReferenceType ? this.lastDdr.depthReferenceType : "0",
        dailyTotalCost: 0,
        dailySummary: "",
        currentStatus: "",
        dailyForecast: "",
        dailyChallenge: "",
        lumpedCosts: [],
        targets: [],
        cost: { budgetTemplateId: "", budgetLines: [] },
        projectCost: { budgetTemplateId: "", budgetLines: [] },
        mud: {
          mudType: "",
          mudWeight: "0",
          funnelViscosity: "0",
          eCD: "0",
          plasticViscosity: "0",
          yieldPoint: "0",
          gelStrength: "0",
          pitTemp: "0",
          hTHP: "0",
          cake: "0",
          solids: "0",
          dailyMudCost: "0",
          prevMudCost: "0",
          totalMudCost: "0",
        },
        depthSummaryModel: {
          currentHoleSize: this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.currentHoleSize : "0",
          currentDepth: "0",
          totalDepth: this.selectedProject.well && this.selectedProject.well.totalDepthMD ? this.selectedProject.well.totalDepthMD.value : "0",
          actualTotalDepth: this.dailyReport.depthSummaryModel.currentDepth,
          previousDepth: this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.currentDepth : "0",
          depthProgress: "0",
          casingType: this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.casingType : "Conductor",
          casingSize: this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.casingSize : "0",
          casingDepth: this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.casingDepth : "0",
          topOfLiner: "0",
          lot: "0",
          fit: "0",
        },
        scheduleModel: {
          plannedRigMoveStartDate: this.rigMove?this.rigMove.start: null,
          plannedRigMoveEndDate: this.rigMove?this.rigMove.end: null,
          plannedRigMoveDays: this.rigMove?this.getDaysDifference(this.dailyReport.scheduleModel.plannedRigMoveStartDate, this.dailyReport.scheduleModel.plannedRigMoveEndDate): 0,
          plannedOperationsDays: this.getDaysDifference(this.selectedProject.start, this.selectedProject.end),
          actualRigMoveDays: this.lastDdr && this.lastDdr.schedule ? this.lastDdr.schedule.actualRigMoveDays : 0,
          rigMoveStartDate: this.lastDdr && this.lastDdr.schedule ? this.lastDdr.schedule.rigMoveStartDate : null,
          rigMoveEndDate: this.lastDdr && this.lastDdr.schedule ? this.lastDdr.schedule.rigMoveEndDate : null,
          spudDate: this.lastDdr && this.lastDdr.schedule ? this.lastDdr.schedule.spudDate : null,
          spudTime:  this.lastDdr && this.lastDdr.spudTime ? this.lastDdr.schedule.spudTime : (this.dailyReport.scheduleModel.spudTime || "06:00"),
          daysOnLocation: this.rigMove?this.getDaysDifference(currentDate, this.rigMove.end): "0",
          daysFromSpud: this.dailyReport.scheduleModel.spudDate ?this.getDaysDifference(currentDate, this.dailyReport.scheduleModel.spudDate):0,
          operatingDaysVariance: this.dailyReport.scheduleModel.plannedOperationsDays - this.dailyReport.scheduleModel.daysFromSpud
        },
        aFESummaryModel: {
          code: '',
          supplementaryCode: '',
          amount: "0",
          supplementaryAmount: "0",
          actualBudgetRatio: "0",
          supplementaryBudgetRatio: "0",
          dailyCost: 0,
          cummulativeCost: this.lastDdr && this.dailyReport.afeSummary ? this.calculateAfeCummulativeCost(this.dailyReport.reportDate) + this.dailyReport.aFESummaryModel.dailyCost : this.dailyReport.aFESummaryModel.dailyCost,
          percentage: "0",
          suppPercentage: "0",
          isAmount: false
        },
        mudVolume: {
          volTotMudStart: "0",
          volMudDumped: "0",
          volMudReceived: "0",
          volMudReturned: "0",
          volMudBuilt: "0",
          volMudString: "0",
          volMudCasing: "0",
          volMudHole: "0",
          volMudRiser: "0",
        },
        mudLosses: {
          volLostShakerSurf: "0",
          volLostMudCleanerSurf: "0",
          volLostPitsSurf: "0",
          volLostTrippingSurf: "0",
          volLostOtherSurf: "0",
          volLostCircHole: "0",
          volLostCsgHole: "0",
          volLostCmtHole: "0",
          volLostBhdCsgHole: "0",
          volLostAbandonHole: "0",
          volLostOtherHole: "0",
        },
        personnelContactsLog: [] as Array<any>,
        timeBreakDown: {
          circulation: "0",
          rIH: "0",
          pOOH: "0",
          drilling: "0",
          cementing: "0",
          tCP: "0",
          others: "0",
        },
        safetyModel: {
          lastBOPDrill: null,
          nextBOPTest: null,
          lastSafetyMeeting: null,
          lastFireDrill: null,
          lastBOPTest: null,
          lastCsgPres: null,
        },
        bitModel: {
          bha: "0",
          bitSize: "0",
          modelNo: '',
          bitType: '',
          iadcNo: "0",
          serialNo: "0",
          bitHours: "0",
          bitNozzless: "0",
          tfa: "0",
          impact: "0",
          jetVelocity: "0",
          rop: "0",
          rpm: "0",
          bitRevolution: "0",
          bitRotationHours: "0",
          averageCummulative: "0",
          wob: "0",
          footage: "0"
      },
      deviationSurveyData: [] as Array<any>,
      drillingParametersModel: {
        torque: "0",
        depth: "0",
        puWeight: "0",
        soWeight: "0",
        maxOPull: "0",
        rotatingWeight: "0",
      },
      personnelOnBoardLog: [] as Array<any>
    };
    }

    get settingswellFluid():Array<any> {
        return this.$store.getters['settingsModule/getSettingsWell']
    }

    get fetchColorSettings():any {
        return this.$store.dispatch('settingsModule/getColorSettings')
    }

    get getWellFluidType():Array<any> {
        let wellTypeOptions: Array<any>=[]
        this.settingswellFluid.forEach((wellType: any)=>{
            wellTypeOptions.push({text:wellType.propertyName,value:wellType.propertyName})
        })
        return wellTypeOptions
    }

    get getDepartmentOptions() {
        return this.$store.getters['departmentModule/getAllDepartments']
    }

    get contractorAndServicesOptions() {
        return this.$store.getters['settingsModule/getContractorAndServices']
    }

    get projectCostRowsData() {
      if(!this.selectedProject.approvedBudget || this.selectedProject.approvedBudget === null || this.selectedProject.approvedBudget.budgetTemplateId < 1) return [];
      let rows: Array<any> = []
        let allReportByProjectCost: Array<any> = []
      let budgetTemplate = this.budgetTemplates && this.budgetTemplates.length ? this.budgetTemplates.find((thisBudgetTeplate:any) => thisBudgetTeplate.id == this.selectedProject.approvedBudget.budgetTemplateId) : null;
      if(!budgetTemplate && budgetTemplate == null) return [];
      let allLineItems:Array<any> = []
        budgetTemplate.sections.forEach((s: any) => {
          s.budgetLineItems.forEach((l: any) => {
              allLineItems.push({ ...l, sectionName: s.sectionName });
          });
      });

      const currentBudget = {
          budgetTemplateId: budgetTemplate.id,
          budgetLines: allLineItems.map((l: any) => ({
              lineItemId: l.id,
              lineSplit: l.lineSplit,
              lineValue: 0,
              lineItemName: l.lineItem,
              sectionName: l.sectionName,
          })),
          projectId: this.selectedProject.id,
      };

      if(this.ddrs && this.ddrs.length > 0){
        allReportByProjectCost = this.ddrs.flatMap((report: any) => {
          if (report.projectCost && report.projectCost.budgetLines.length > 0) {
            return report.projectCost.budgetLines;
          } 
        })
      }

      allLineItems.forEach((item: any) => {
        const projectCostBudgetLine = !this.dailyReport.projectCost || this.dailyReport.projectCost === null ? currentBudget.budgetLines.find((l: any) => l.lineItemId == item.id) : this.dailyReport.projectCost.budgetLines.find((l: any) => l.lineItemId == item.id);
        const lineItemToSum = allReportByProjectCost.filter((x:any) => x && x.lineItemId === item.id);
        let totalLineValue = 0;
        if (lineItemToSum && lineItemToSum.length > 0) {
          totalLineValue = lineItemToSum.reduce((sum: number, currentItem: any) => {
            return sum + (currentItem.lineValue || 0);
          }, 0);
        }
        rows.push({
          id: item.id,
          lineItem: item.lineItem,
          sectionName: item.sectionName,
          dailyCost: projectCostBudgetLine ? projectCostBudgetLine.lineValue : 0,
          projectId: this.selectedProject.id,
          budgetTemplateId: budgetTemplate.id,
          lineSum: totalLineValue,
        });
      });

      return rows;
    }

    get newRowsData():any{
      let result:any = {rows:[],groupExtractor:undefined}
      let budgetTemplatesToProcess:Array<any> = []
      let budgetLinesForThisMilestone: Array<any> = []
      let allReportByActivity: Array<any> = []
      this.dailyReport.activityLog.forEach((a:any) => {
        if(a.activity!=null && a.milestone != null && a.activity.budget!=undefined){
          if(budgetTemplatesToProcess.findIndex((b:any)=>b.id==a.activity.budget.budgetTemplateId)<0){
            const dept = this.getDepartmentOptions.find((d:any) => d.id === a.activity.departmentId);
            const operationUnit = dept.operationUnits.find((o:any) => o.id === a.activity.operationUnitId)
            const exist = budgetTemplatesToProcess.find((x:any) => x.departmentId === dept.id && x.activityId === a.milestone.id)
            if (!exist) {
              const template = this.budgetTemplates.find((b:any)=>b.id==a.activity.budget.budgetTemplateId);
              budgetTemplatesToProcess.push({
                activityId: a.milestone && a.milestone !== null ? a.milestone.id : a.activity.id,
                milestone: a.milestone && a.milestone !== null ? a.milestone.name : a.activity.name,
                department: dept.name,
                departmentId: dept.id,
                operationUnit: operationUnit.name,
                budgetTemplate: this.budgetTemplates.find((b:any)=>b.id==a.activity.budget.budgetTemplateId),
                budgetTemplateId: template ? a.activity.budget.budgetTemplateId : ''
              })
            }
          }
        }
      })
      if(budgetTemplatesToProcess.length>0){
        budgetTemplatesToProcess.sort((a, b) => parseInt(a.departmentId) - parseInt(b.departmentId));
        budgetTemplatesToProcess.forEach((budgetTemplate:any)=>{
          if(this.dailyReport.cost&&this.dailyReport.cost.budgetLines){
            budgetLinesForThisMilestone = this.dailyReport.cost.budgetLines.filter((b:any) => b.activityId == budgetTemplate.activityId)
          }
          if(this.ddrs && this.ddrs.length > 0){
            allReportByActivity = this.ddrs.flatMap((report: any) => {
              if (report.cost && report.cost.budgetLines.length > 0) {
                return report.cost.budgetLines.filter((x: any) => String(x.activityId) === String(budgetTemplate.activityId))
              } 
            })
          }

          result.groupExtractor = (s:any)=>({key:s.id,label:s.sectionName,rows:s.budgetLineItems})
          budgetTemplate.budgetTemplate.sections.forEach((section:any)=>{
            result.rows.push({
              activityId: budgetTemplate.activityId,
              department: budgetTemplate.department,
              milestone: budgetTemplate.milestone,
              operationunit: budgetTemplate.operationUnit,
              section: section,
              budgetLinesForMilestone: budgetLinesForThisMilestone,
              allReportByActivity: allReportByActivity
            })
          })
        })
      }
      return result;
    }

    get lumpSumRowsData():any{
      let result:any = {rows:[],groupExtractor:undefined}
      let budgetTemplatesToProcess:Array<any> = []
      let budgetLinesForThisMilestone: Array<any> = []
      this.dailyReport.activityLog.forEach((a:any) => {
        if(a.activity!=null && a.milestone != null && a.activity.budget!=undefined){
          if(budgetTemplatesToProcess.findIndex((b:any)=>b.id==a.activity.budget.budgetTemplateId)<0){
            const dept = this.getDepartmentOptions.find((d:any) => d.id === a.activity.departmentId);
            const operationUnit = dept.operationUnits.find((o:any) => o.id === a.activity.operationUnitId)

            const exist = budgetTemplatesToProcess.find((x:any) => x.departmentId === dept.id)
            if (!exist) {
              const template = this.budgetTemplates.find((b:any)=>b.id==a.activity.budget.budgetTemplateId);
              budgetTemplatesToProcess.push({
                activityId: a.milestone && a.milestone !== null ? a.milestone.id : a.activity.id,
                department: dept.name,
                departmentId: dept.id,
                operationUnit: operationUnit.name,
                operationUnitId: operationUnit.id,
                budgetTemplate: template,
                budgetTemplateId: template ? a.activity.budget.budgetTemplateId : ''
              })
            }
          }
        }
      })
      if(budgetTemplatesToProcess.length>0){
        budgetTemplatesToProcess.sort((a, b) => parseInt(a.departmentId) - parseInt(b.departmentId));
        budgetTemplatesToProcess.forEach((budgetTemplate:any)=>{
          if(this.dailyReport.lumpedCosts&&this.dailyReport.lumpedCosts.length > 0){
            budgetLinesForThisMilestone = this.dailyReport.lumpedCosts.filter((b: any) => 
                String(b.activityId).trim() === String(budgetTemplate.activityId).trim() &&
                String(b.departmentId).trim() === String(budgetTemplate.departmentId).trim()
            );
          }
          
          result.rows.push({
              activityId: budgetTemplate.activityId,
              department: budgetTemplate.department,
              departmentId: budgetTemplate.departmentId,
              operationUnitId: budgetTemplate.operationUnitId,
              lineValue: 0,
              budgetLinesForThisMilestone: budgetLinesForThisMilestone
            })
        })
      }
      return result;
    }    
  
    get nptOperations(){
         return this.$store.getters["nptModule/getAllNpt"];
    }

    get fetchNptSettings() {
        return this.$store.dispatch('settingsModule/getNptSettings')
    }

    get nptSettings() {
        return this.$store.getters['settingsModule/getNptSettings']
    }
  
    get budgetTemplates(){
      return this.$store.getters["budgetTemplateModule/getAllTemplates"]
    }
  
    cummulativePercentage(a: any, b: any, c: any) {
      let d = Number(b)+Number(c)
      let q = Number(a)/Number(d)
      let v = q*100
      return v.toFixed(2)
    }
    
    percentage(a: any, b: any) {
      let q = b/a
      let v = q * 100
      return v.toFixed(2)
    }
  
    setDailyReportProperties() {
      if (this.editedReport && this.editedReport.deviationSurveys) {
        var currentReportDeviationSurvey = this.editedReport.deviationSurveys.filter((x:any)=>x.dailyReportId == this.editedReport.id)
      }
      const mud = this.editedReport && this.editedReport.mud ? {
        mudType: this.editedReport.mud.mudType,
        mudWeight: this.editedReport.mud.mudWeight,
        funnelViscosity: this.editedReport.mud.funnelViscosity,
        eCD: this.editedReport.mud.ecd,
        plasticViscosity: this.editedReport.mud.plasticViscosity,
        yieldPoint: this.editedReport.mud.yieldPoint,
        gelStrength: this.editedReport.mud.gelStrength,
        pitTemp: this.editedReport.mud.pitTemp,
        hTHP: this.editedReport.mud.hthp,
        cake: this.editedReport.mud.cake,
        solids: this.editedReport.mud.solids,
        dailyMudCost: this.editedReport.mud.dailyMudCost,
        prevMudCost: this.editedReport.mud.prevMudCost,
        totalMudCost: this.editedReport.mud.totalMudCost,
      } : {};
      const unitSystem = this.editedReport && this.editedReport.unitSystem ? this.editedReport.unitSystem.toLowerCase() :this.currentUnitSystem.toLowerCase();
      this.dailyReport = {
          id:this.editedReport.id,
          startDepth: convertUnit(this.editedReport.startDepth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
          endDepth: convertUnit(this.editedReport.endDepth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
          depthReference: convertUnit(this.editedReport.depthReference, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
          depthReferenceType: this.editedReport.depthReferenceType,
          dailySummary: this.editedReport.dailySummary,
          currentStatus: this.editedReport.currentStatus,
          dailyForecast: this.editedReport.dailyForecast,
          dailyChallenge: this.editedReport.dailyChallenge,
          unitSystem: this.editedReport.unitSystem,
          reportDate: this.editedReport.reportDate,
          startTime: this.editedReport && this.editedReport.activityLog && this.editedReport.activityLog[0] ? this.editedReport.activityLog[0].from : this.editedReport.startTime,
          endTime: this.editedReport && this.editedReport.activityLog && this.editedReport.activityLog[this.editedReport.activityLog.length - 1] ? this.editedReport.activityLog[this.editedReport.activityLog.length - 1].to : this.editedReport.endTime,
          selectedViews: this.editedReport.selectedViews && this.editedReport.selectedViews.length > 0 ? this.editedReport.selectedViews : ['General', 'Activity Logs', 'Cost and AFE Summary'],
          cost: this.editedReport.cost,
          projectCost: this.editedReport.projectCost,
          dailyTotalCost: this.editedReport.dailyTotalCost,
          lumpedCosts: this.editedReport.lumpedCosts,
          targets: this.editedReport.targets,
          mud: mud,
          depthSummaryModel: this.editedReport && this.editedReport.depthSummary ? {
            currentHoleSize: this.editedReport.depthSummary.currentHoleSize,
            currentDepth: convertUnit(this.editedReport.depthSummary.currentDepth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            totalDepth: convertUnit(this.editedReport.depthSummary.totalDepth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            depthProgress: convertUnit(this.editedReport.depthSummary.depthProgress, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            previousDepth: convertUnit(this.editedReport.depthSummary.previousDepth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            actualTotalDepth: convertUnit(this.editedReport.depthSummary.actualTotalDepth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            casingSize: this.editedReport.depthSummary.casingSize,
            casingDepth: convertUnit(this.editedReport.depthSummary.casingDepth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            casingType: this.editedReport.depthSummary.casingType,
            topOfLiner: convertUnit(this.editedReport.depthSummary.topOfLiner, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            lot: this.editedReport && this.editedReport.depthSummary ? this.editedReport.depthSummary.lot : 0,
            fit: this.editedReport && this.editedReport.depthSummary ? this.editedReport.depthSummary.fit : 0,
          } : {},
          scheduleModel: this.editedReport && this.editedReport.schedule ? {
            plannedRigMoveStartDate: this.editedReport.schedule.plannedRigMoveStartDate || null,
            plannedRigMoveEndDate: this.editedReport.schedule.plannedRigMoveEndDate || null,
            plannedRigMoveDays: this.editedReport.schedule.plannedRigMoveDays,
            plannedOperationsDays: this.editedReport.schedule.plannedOperationsDays,
            actualRigMoveDays: this.editedReport.schedule.actualRigMoveDays,
            rigMoveStartDate: this.editedReport.schedule.rigMoveStartDate || null,
            rigMoveEndDate: this.editedReport.schedule.rigMoveEndDate || null,
            spudDate: this.editedReport.schedule.spudDate || null,
            spudTime: this.editedReport.schedule.spudTime || "06:00",
            daysOnLocation: this.editedReport.schedule.daysOnLocation,
            daysFromSpud: this.editedReport.schedule.daysFromSpud,
            operatingDaysVariance: this.editedReport.schedule.operatingDaysVariance,
          } : {},
          aFESummaryModel: this.editedReport && this.editedReport.afeSummary ? {
            code: this.editedReport.afeSummary.code,
            supplementaryCode: this.editedReport.afeSummary.supplementaryCode,
            amount: this.editedReport.afeSummary.amount,
            supplementaryAmount: this.editedReport.afeSummary.supplementaryAmount,
            actualBudgetRatio: this.editedReport.afeSummary.actualBudgetRatio,
            supplementaryBudgetRatio: this.editedReport.afeSummary.supplementaryBudgetRatio,
            dailyCost: this.editedReport.afeSummary.dailyCost,
            cummulativeCost: this.editedReport.afeSummary.cummulativeCost,
            percentage: this.editedReport.afeSummary.percentageSpent,
            suppPercentage: this.editedReport.afeSummary.supplementaryPercentageSpent,
            isAmount: this.editedReport.afeSummary.isAmount,
          } : {},
          mudVolume: this.editedReport && this.editedReport.mudVolume ? {
            volTotMudStart: convertUnit(this.editedReport.mudVolume.startVolume, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volMudDumped: convertUnit(this.editedReport.mudVolume.mudDumped, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volMudReceived: convertUnit(this.editedReport.mudVolume.mudReceived, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volMudReturned: convertUnit(this.editedReport.mudVolume.mudReturned, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volMudBuilt: convertUnit(this.editedReport.mudVolume.mudBuilt, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volMudString: convertUnit(this.editedReport.mudVolume.mudWithinActiveString, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volMudCasing: convertUnit(this.editedReport.mudVolume.mudContainedInCasing, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volMudHole: convertUnit(this.editedReport.mudVolume.mudInOpenAnnulus, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volMudRiser: convertUnit(this.editedReport.mudVolume.mudInRiserSection, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3')
          } : {},
          mudLosses: this.editedReport && this.editedReport.mudLosses ? {
            volLostShakerSurf: convertUnit(this.editedReport.mudLosses.shaker, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostMudCleanerSurf: convertUnit(this.editedReport.mudLosses.cleaningEquipment, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostPitsSurf: convertUnit(this.editedReport.mudLosses.pitRoom, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostTrippingSurf: convertUnit(this.editedReport.mudLosses.tripping, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostOtherSurf: convertUnit(this.editedReport.mudLosses.otherSurface, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostCircHole: convertUnit(this.editedReport.mudLosses.circulating, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostCsgHole: convertUnit(this.editedReport.mudLosses.runningCasing, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostCmtHole: convertUnit(this.editedReport.mudLosses.cementing, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostBhdCsgHole: convertUnit(this.editedReport.mudLosses.behindCasing, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostAbandonHole: convertUnit(this.editedReport.mudLosses.abandonment, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
            volLostOtherHole: convertUnit(this.editedReport.mudLosses.otherLocation, this.currentUnitSystem, unitSystem === 'field' ? 'bbl' : 'm3'),
          } : {},
          personnelContactsLog: this.editedReport && this.editedReport.personnelContactsLog ? this.editedReport.personnelContactsLog.map(
            (personnelContact: any) => ({
              id:personnelContact.id,
              position: personnelContact.position,
              contactName: personnelContact.contactName,
              company: personnelContact.company,
              email: personnelContact.email,
              office: personnelContact.office,
              mobile: personnelContact.mobile,
            })
          ) : [],
          personnelOnBoardLog: this.editedReport && this.editedReport.personnelonBoards ? this.editedReport.personnelonBoards.map(
            (personnelOnBoards: any) => ({
              id:personnelOnBoards.id,
              company: personnelOnBoards.company,
              serviceType: personnelOnBoards.serviceType,
              workHour: personnelOnBoards.workHour,
              standByHour: personnelOnBoards.standByHour,
              count: personnelOnBoards.count,
              note: personnelOnBoards.note,
            })
          ) : [],
          deviationSurveyData: currentReportDeviationSurvey && currentReportDeviationSurvey.length ? currentReportDeviationSurvey.map(
            (deviationSurvey: any) => ({
              id:deviationSurvey.id,
              mD: convertUnit(deviationSurvey.md, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
              inclinationAngle: deviationSurvey.inclinationAngle,
              azimuth: deviationSurvey.azimuth,
              tVD: convertUnit(deviationSurvey.tvd, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
              verticalSection: convertUnit(deviationSurvey.verticalSection, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
              nS: convertUnit(deviationSurvey.ns, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
              eW: convertUnit(deviationSurvey.ew, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
              dLS: deviationSurvey.dls,
            })
          ) : [],
          timeBreakDown: this.editedReport && this.editedReport.timeBreakDown ? {
            circulation: this.editedReport.timeBreakDown.circulation,
            rIH:this.editedReport.timeBreakDown.rih,
            pOOH: this.editedReport.timeBreakDown.pooh,
            drilling: this.editedReport.timeBreakDown.drilling,
            cementing: this.editedReport.timeBreakDown.cementing,
            tCP:this.editedReport.timeBreakDown.tcp,
            others: this.editedReport.timeBreakDown.others,
          } : {},
          safetyModel: this.editedReport && this.editedReport.safety ? {
            lastBOPDrill: this.editedReport.safety.lastBOPDrill,
            nextBOPTest: this.editedReport.safety.nextBOPTest,
            lastSafetyMeeting: this.editedReport.safety.lastSafetyMeeting,
            lastFireDrill: this.editedReport.safety.lastFireDrill,
            lastBOPTest: this.editedReport.safety.lastBOPTest,
            lastCsgPres: this.editedReport.safety.lastCsgPres,
          } : {},
          drillingParametersModel: this.editedReport && this.editedReport.drillingParameter ? {
            torque: this.editedReport.drillingParameter.torque,
            depth: convertUnit(this.editedReport.drillingParameter.depth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            puWeight: convertUnit(this.editedReport.drillingParameter.puWeight, this.currentUnitSystem, unitSystem === 'field' ? 'ft2' : 'm2'),
            soWeight: convertUnit(this.editedReport.drillingParameter.soWeight, this.currentUnitSystem, unitSystem === 'field' ? 'ft2' : 'm2'),
            maxOPull: convertUnit(this.editedReport.drillingParameter.maxOPull, this.currentUnitSystem, unitSystem === 'field' ? 'ft2' : 'm2'),
            rotatingWeight: convertUnit(this.editedReport.drillingParameter.rotatingWeight, this.currentUnitSystem, unitSystem === 'field' ? 'ft2' : 'm2')
          } : {},
          bitModel: this.editedReport && this.editedReport.bit ? {
            bha: this.editedReport.bit.bha,
            bitSize: this.editedReport.bit.bitSize,
            modelNo: this.editedReport.bit.modelNo,
            bitType: this.editedReport.bit.bitType,
            iadcNo: this.editedReport.bit.iadcNo,
            serialNo: this.editedReport.bit.serialNo,
            bitHours: this.editedReport.bit.bitHours,
            bitNozzless: this.editedReport.bit.bitNozzless,
            tfa: convertUnit(this.editedReport.bit.tfa, this.currentUnitSystem, unitSystem === 'field' ? 'ft2' : 'm2'),
            impact: convertUnit(this.editedReport.bit.impact, this.currentUnitSystem, unitSystem === 'field' ? 'lbf' : 'N'),
            jetVelocity: this.editedReport.bit.jetVelocity,
            rop: this.editedReport.bit.rop,
            rpm: this.editedReport.bit.rpm,
            bitRevolution: this.editedReport.bit.bitRevolution,
            bitRotationHours: this.editedReport.bit.bitRotationHours,
            averageCummulative: this.editedReport.bit.averageCummulative,
            wob: convertUnit(this.editedReport.bit.wob, this.currentUnitSystem, unitSystem === 'field' ? 'lbf' : 'N'),
            footage: convertUnit(this.editedReport.bit.footage, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm')
          } : {},
          activityLog : this.editedReport && this.editedReport.activityLog ? this.editedReport.activityLog.map((logEntry:any) => ({
            id:logEntry.id,
            from: logEntry.from,
            to: logEntry.to,
            hasNpt: logEntry.hasNpt,
            activity:  this.activitiesForProject.find((activityInProject:any)=> activityInProject.id == logEntry.activityInProjectId),
            milestone: (() => {
              const activity = this.activitiesForProject.find(
                (activityInProject: any) => activityInProject.id === logEntry.activityInProjectId
              );
              
              return activity && Array.isArray(activity.milestones) 
                ? activity.milestones.find((milestone: any) => milestone.id === logEntry.activityId) 
                : null;
            })(),
            description: logEntry.description,
            depth: convertUnit(logEntry.depth, this.currentUnitSystem, unitSystem === 'field' ? 'ft' : 'm'),
            nptOperation: this.nptSettings.find((nptOperation:any)=> nptOperation.id == logEntry.npt.nptOperationId),
            nptOperationId: logEntry && logEntry.npt.nptOperationId ? logEntry.npt.nptOperationId : '',
            nptCategory: logEntry && logEntry.nptCategory ? logEntry.nptCategory : '',
            rootCause: logEntry && logEntry.rootCause ? logEntry.rootCause : '',
            contractor: logEntry.contractor ? logEntry.contractor : '',
            service: logEntry.service ? logEntry.service : '',
            nptDescription: logEntry.npt && logEntry.npt.nptDescription ? logEntry.npt.nptDescription : '',
            nptHours: logEntry.npt && logEntry.npt.nptHours ? logEntry.npt.nptHours : '',
          })) : []
        }
    }
  
    get DDR () {
      return  {
        id:this.dailyReport.id,
        startDepth:  this.dailyReport.startDepth,
        endDepth:  this.dailyReport.endDepth,
        depthReference: this.dailyReport.depthReference,
        depthReferenceType: this.dailyReport.depthReferenceType,
        dailySummary: this.dailyReport.dailySummary,
        currentStatus: this.dailyReport.currentStatus,
        dailyForecast: this.dailyReport.dailyForecast,
        dailyChallenge: this.dailyReport.dailyChallenge,
        unitSystem: this.dailyReport.unitSystem,
        reportDate: this.dailyReport.reportDate,
        startTime: this.dailyReport && this.dailyReport.activityLog && this.dailyReport.activityLog[0] ? this.dailyReport.activityLog[0].from : this.editedReport.startTime,
        endTime: this.dailyReport && this.dailyReport.activityLog && this.dailyReport.activityLog[this.dailyReport.activityLog.length - 1] ? this.dailyReport.activityLog[this.dailyReport.activityLog.length - 1].to : this.editedReport.endTime,
        selectedViews: this.dailyReport.selectedViews ? this.dailyReport.selectedViews : ['General', 'Activity Logs', 'Cost and AFE Summary'],
        cost: this.dailyReport.cost,
        projectCost: this.dailyReport.projectCost,
        dailyTotalCost: this.dailyReport.dailyTotalCost,
        lumpedCosts: this.dailyReport.lumpedCosts,
        targets: this.dailyReport.targets,
        activityLog: this.dailyReport.activityLog.map((logEntry: any) => ({
          id:logEntry.id,
          from: logEntry.from,
          to: logEntry.to,
          activityInProjectName: logEntry.activity != null ? logEntry.activity.name: "",
          activityName:logEntry.milestone != null ? logEntry.milestone.name: "",
          hasNpt: logEntry.hasNpt,
          activityInProjectId: logEntry.activityInProjectId,
          activityId: logEntry.activityId,
          description: logEntry.description,
          depth: logEntry.depth,
          nptCategory:logEntry.hasNpt && logEntry.nptCategory ? logEntry.nptCategory : "",
          rootCause:logEntry.hasNpt && logEntry.rootCause ? logEntry.rootCause : "",
          contractor: logEntry.contractor ? logEntry.contractor : "",
          service: logEntry.service ? logEntry.service : "",
          npt:{
            nptHours:logEntry.hasNpt? logEntry.nptHours: "",
            nptDescription: logEntry.hasNpt? logEntry.nptDescription: "",
          }
        })),
        mud: {
          mudType: this.dailyReport.mud.mudType,
          mudWeight: this.dailyReport.mud.mudWeight,
          funnelViscosity: this.dailyReport.mud.funnelViscosity,
          ecd: this.dailyReport.mud.eCD,
          plasticViscosity: this.dailyReport.mud.plasticViscosity,
          yieldPoint: this.dailyReport.mud.yieldPoint,
          gelStrength: this.dailyReport.mud.gelStrength,
          pitTemp: this.dailyReport.mud.pitTemp,
          hthp: this.dailyReport.mud.hTHP,
          cake: this.dailyReport.mud.cake,
          solids: this.dailyReport.mud.solids,
          dailyMudCost: this.dailyReport.mud.dailyMudCost,
          prevMudCost: this.dailyReport.mud.prevMudCost,
          totalMudCost: this.dailyReport.mud.totalMudCost,
        },
        depthSummary: {
          currentHoleSize: this.dailyReport.depthSummaryModel.currentHoleSize,
          currentDepth: this.dailyReport.depthSummaryModel.currentDepth,
          totalDepth: this.dailyReport.depthSummaryModel.totalDepth,
          depthProgress: this.dailyReport.depthSummaryModel.depthProgress,
          previousDepth: this.dailyReport.depthSummaryModel.previousDepth,
          actualTotalDepth: this.dailyReport.depthSummaryModel.actualTotalDepth,
          casingSize: this.dailyReport.depthSummaryModel.casingSize,
          casingDepth: this.dailyReport.depthSummaryModel.casingDepth,
          casingType: this.dailyReport.depthSummaryModel.casingType,
          topOfLiner: this.dailyReport.depthSummaryModel.topOfLiner,
          lot: this.dailyReport.depthSummaryModel.lot,
          fit: this.dailyReport.depthSummaryModel.fit,
        },
        schedule: {
          plannedRigMoveStartDate: this.dailyReport.scheduleModel.plannedRigMoveStartDate,
          plannedRigMoveEndDate: this.dailyReport.scheduleModel.plannedRigMoveEndDate,
          plannedRigMoveDays: this.dailyReport.scheduleModel.plannedRigMoveDays,
          plannedOperationsDays: this.dailyReport.scheduleModel.plannedOperationsDays,
          actualRigMoveDays: this.dailyReport.scheduleModel.actualRigMoveDays,
          rigMoveStartDate: this.dailyReport.scheduleModel.rigMoveStartDate,
          rigMoveEndDate: this.dailyReport.scheduleModel.rigMoveEndDate,
          spudDate: this.dailyReport.scheduleModel.spudDate,
          spudTime: this.dailyReport.scheduleModel.spudTime,
          daysOnLocation: this.dailyReport.scheduleModel.daysOnLocation,
          daysFromSpud: this.dailyReport.scheduleModel.daysFromSpud,
          operatingDaysVariance: this.dailyReport.scheduleModel.operatingDaysVariance,
        },
        afeSummary: {
          code: this.dailyReport.aFESummaryModel.code,
          supplementaryCode: this.dailyReport.aFESummaryModel.supplementaryCode,
          amount: this.dailyReport.aFESummaryModel.amount,
          supplementaryAmount: this.dailyReport.aFESummaryModel.supplementaryAmount,
          actualBudgetRatio: this.dailyReport.aFESummaryModel.actualBudgetRatio,
          supplementaryBudgetRatio: this.dailyReport.aFESummaryModel.supplementaryBudgetRatio,
          dailyCost: this.dailyReport.aFESummaryModel.dailyCost,
          cummulativeCost: this.dailyReport.aFESummaryModel.cummulativeCost,
          percentage: this.dailyReport.aFESummaryModel.percentage,
          suppPercentage: this.dailyReport.aFESummaryModel.suppPercentage,
          isAmount: this.dailyReport.aFESummaryModel.isAmount,
        },
        mudVolume: {
          startVolume: this.dailyReport.mudVolume.volTotMudStart,
          mudDumped: this.dailyReport.mudVolume.volMudDumped,
          mudReceived:this.dailyReport.mudVolume.volMudReceived,
          mudReturned: this.dailyReport.mudVolume.volMudReturned,
          mudBuilt: this.dailyReport.mudVolume.volMudBuilt,
          mudWithinActiveString: this.dailyReport.mudVolume.volMudString,
          mudContainedInCasing: this.dailyReport.mudVolume.volMudCasing,
          mudInOpenAnnulus: this.dailyReport.mudVolume.volMudHole,
          mudInRiserSection: this.dailyReport.mudVolume.volMudRiser,
        },
        mudLosses: {
          shaker: this.dailyReport.mudLosses.volLostShakerSurf,
          cleaningEquipment: this.dailyReport.mudLosses.volLostMudCleanerSurf,
          pitRoom: this.dailyReport.mudLosses.volLostPitsSurf,
          tripping: this.dailyReport.mudLosses.volLostTrippingSurf,
          otherSurface: this.dailyReport.mudLosses.volLostOtherSurf,
          circulating: this.dailyReport.mudLosses.volLostCircHole,
          runningCasing: this.dailyReport.mudLosses.volLostCsgHole,
          cementing:this.dailyReport.mudLosses.volLostCmtHole,
          behindCasing: this.dailyReport.mudLosses.volLostBhdCsgHole,
          abandonment: this.dailyReport.mudLosses.volLostAbandonHole,
          otherLocation:this.dailyReport.mudLosses.volLostOtherHole,
        },
        personnelContactsLog: this.dailyReport.personnelContactsLog.map(
          (personnelContact: any) => ({
            id:personnelContact.id,
            position: personnelContact.position,
            contactName: personnelContact.contactName,
            company: personnelContact.company,
            email: personnelContact.email,
            office: personnelContact.office,
            mobile: personnelContact.mobile,
          })
        ),
        personnelonBoards: this.dailyReport.personnelOnBoardLog.map(
          (personnelOnBoards: any) => ({
            id:personnelOnBoards.id,
            company: personnelOnBoards.company,
            serviceType: personnelOnBoards.serviceType,
            workHour: personnelOnBoards.workHour,
            standByHour: personnelOnBoards.standByHour,
            count: personnelOnBoards.count,
            note: personnelOnBoards.note,
          })
        ),
        deviationSurveys: this.dailyReport.deviationSurveyData.map(
          (deviationSurvey: any) => ({
            md:deviationSurvey.mD,
            inclinationAngle: deviationSurvey.inclinationAngle,
            azimuth: deviationSurvey.azimuth,
            tvd: deviationSurvey.tVD,
            verticalSection: deviationSurvey.verticalSection,
            ns: deviationSurvey.nS,
            ew: deviationSurvey.eW,
            dls: deviationSurvey.dLS,
          })
        ),
        timeBreakDown: {
          circulation: this.dailyReport.timeBreakDown.circulation,
          rih:this.dailyReport.timeBreakDown.rIH,
          pooh: this.dailyReport.timeBreakDown.pOOH,
          drilling: this.dailyReport.timeBreakDown.drilling,
          cementing: this.dailyReport.timeBreakDown.cementing,
          tcp:this.dailyReport.timeBreakDown.tCP,
          others: this.dailyReport.timeBreakDown.others,
        },
        safety: {
          lastBOPDrill: this.dailyReport.safetyModel.lastBOPDrill,
          nextBOPTest: this.dailyReport.safetyModel.nextBOPTest,
          lastSafetyMeeting: this.dailyReport.safetyModel.lastSafetyMeeting,
          lastFireDrill: this.dailyReport.safetyModel.lastFireDrill,
          lastBOPTest: this.dailyReport.safetyModel.lastBOPTest,
          lastCsgPres: this.dailyReport.safetyModel.lastCsgPres,
        },
        drillingParameter: {
          torque: this.dailyReport.drillingParametersModel.torque,
          depth: this.dailyReport.drillingParametersModel.depth,
          puWeight: this.dailyReport.drillingParametersModel.puWeight,
          soWeight: this.dailyReport.drillingParametersModel.soWeight,
          maxOPull: this.dailyReport.drillingParametersModel.maxOPull,
          rotatingWeight: this.dailyReport.drillingParametersModel.rotatingWeight,
        },
        bit: {
          bha: this.dailyReport.bitModel.bha,
          bitSize: this.dailyReport.bitModel.bitSize,
          modelNo: this.dailyReport.bitModel.modelNo,
          bitType: this.dailyReport.bitModel.bitType,
          iadcNo: this.dailyReport.bitModel.iadcNo,
          serialNo: this.dailyReport.bitModel.serialNo,
          bitHours: this.dailyReport.bitModel.bitHours,
          bitNozzless: this.dailyReport.bitModel.bitNozzless,
          tfa: this.dailyReport.bitModel.tfa,
          impact: this.dailyReport.bitModel.impact,
          jetVelocity: this.dailyReport.bitModel.jetVelocity,
          rop: this.dailyReport.bitModel.rop,
          rpm: this.dailyReport.bitModel.rpm,
          bitRevolution: this.dailyReport.bitModel.bitRevolution,
          bitRotationHours: this.dailyReport.bitModel.bitRotationHours,
          averageCummulative: this.dailyReport.bitModel.averageCummulative,
          wob: this.dailyReport.bitModel.wob,
          footage: this.dailyReport.bitModel.footage,
        },
      };
    }
    updateReport() {
      this.busy = "LOADING";
      let dailyReport = {
        id:this.dailyReport.id,
        startDepth: this.dailyReport.startDepth,
        endDepth: this.dailyReport.endDepth,
        depthReference: this.dailyReport.depthReference,
        depthReferenceType: this.dailyReport.depthReferenceType,
        unitSystem: this.currentUnitSystem,
        startTime: this.dailyReport && this.dailyReport.activityLog && this.dailyReport.activityLog[0] ? this.convertTimeStringToDate(this.dailyReport.activityLog[0].from) : this.convertTimeStringToDate(this.dailyReport.startTime),
        endTime: this.dailyReport && this.dailyReport.activityLog && this.dailyReport.activityLog[this.dailyReport.activityLog.length - 1] ? this.convertTimeStringToDate(this.dailyReport.activityLog[this.dailyReport.activityLog.length - 1].to) : this.convertTimeStringToDate(this.dailyReport.endTime),
        selectedViews: this.dailyReport.selectedViews,
        reportDate: this.dailyReport.reportDate,
        projectId: this.projectId,
        dailySummary: this.dailyReport.dailySummary,
        currentStatus: this.dailyReport.currentStatus,
        dailyForecast: this.dailyReport.dailyForecast,
        dailyChallenge: this.dailyReport.dailyChallenge,
        cost: {
          budgetLines: this.dailyReport.cost && this.dailyReport.cost.budgetLines && this.dailyReport.cost.budgetLines.length ? this.dailyReport.cost.budgetLines.map((b:any) => ({
            lineValue:b.lineValue,
            lineItemId: String(b.lineItemId),
            activityId:b.activityId
          })) : []
        },
        projectCost: {
          budgetLines: this.dailyReport.projectCost && this.dailyReport.projectCost.budgetLines && this.dailyReport.projectCost.budgetLines.length ? this.dailyReport.projectCost.budgetLines.map((b:any) => ({
            lineValue: b.lineValue,
            lineItemId: String(b.lineItemId),
            projectId: b.projectId
          })) : []
        },
        dailyTotalCost: this.dailyReport.dailyTotalCost,
        lumpedCosts: this.dailyReport.lumpedCosts ? this.dailyReport.lumpedCosts.map((sum:any) => ({
          id: sum.id,
          activityId: sum.activityId,
          departmentId: sum.departmentId,
          operationUnitId: sum.operationUnitId,
          lineValue: sum.lineValue,
        })) : [],        
        targets: this.dailyReport.targets ? this.dailyReport.targets.map((target: any) => ({
          id: target.id,
          reservoirName: target.reservoirName,
          fluidType: target.fluidType,
          actualRate: target.actualRate
        })) : [],
        activityLog: this.dailyReport.activityLog.map((logEntry: any) => ({
          id:logEntry.id,
          from: this.convertTimeStringToDate(logEntry.from),
          to: this.convertTimeStringToDate(logEntry.to),
          hasNpt: logEntry.hasNpt,
          activityInProjectId: logEntry.activity.id,
          activityId: logEntry.milestone && logEntry.milestone.id ? logEntry.milestone.id : -1,
          description: logEntry.description,
          depth: logEntry.depth,
          nptCategory:logEntry.hasNpt && logEntry.nptCategory ? logEntry.nptCategory : "",
          rootCause: logEntry.hasNpt && logEntry.rootCause ? logEntry.rootCause : "",
          contractor: logEntry.contractor ? logEntry.contractor : "",
          service: logEntry.service ? logEntry.service : "",
          npt:{
            nptHours:logEntry.hasNpt && logEntry.nptHours ? logEntry.nptHours : "0",
            nptDescription: logEntry.hasNpt ? logEntry.nptDescription: "",
            nptOperationId: logEntry.hasNpt ? logEntry.nptOperationId ? String(logEntry.nptOperationId) : String(this.nptSettings.find((npt: any) => npt.nptCategory === logEntry.nptCategory).id) : "",
          }
        })),
        mud: {
          mudType: this.dailyReport.mud.mudType || "",
          mudWeight: this.dailyReport.mud.mudWeight,
          funnelViscosity: this.dailyReport.mud.funnelViscosity,
          plasticViscosity: this.dailyReport.mud.plasticViscosity,
          yieldPoint: this.dailyReport.mud.yieldPoint,
          gelStrength: this.dailyReport.mud.gelStrength,
          htHp: this.dailyReport.mud.hTHP,
          cake: this.dailyReport.mud.cake,
          solids: this.dailyReport.mud.solids,
          eCD: this.dailyReport.mud.eCD,
          pitTemp: this.dailyReport.mud.pitTemp,
          dailyMudCost: this.dailyReport.mud.dailyMudCost,
        },
        timeBreakDown: {
          circulation: this.dailyReport.timeBreakDown.circulation,
          rIH: this.dailyReport.timeBreakDown.rIH,
          pOOH: this.dailyReport.timeBreakDown.pOOH,
          drilling: this.dailyReport.timeBreakDown.drilling,
          cementing: this.dailyReport.timeBreakDown.cementing,
          tCP: this.dailyReport.timeBreakDown.tCP,
          others: this.dailyReport.timeBreakDown.others,
        },
        depthSummaryModel: {
          currentHoleSize: this.dailyReport.depthSummaryModel.currentHoleSize,
          currentDepth: this.dailyReport.depthSummaryModel.currentDepth,
          actualTotalDepth: this.dailyReport.depthSummaryModel.actualTotalDepth,
          casingSize: this.dailyReport.depthSummaryModel.casingSize,
          casingDepth: this.dailyReport.depthSummaryModel.casingDepth,
          casingType: this.dailyReport.depthSummaryModel.casingType,
          topOfLiner: this.dailyReport.depthSummaryModel.topOfLiner,
          lot: this.dailyReport.depthSummaryModel.lot,
          fit: this.dailyReport.depthSummaryModel.fit,
        },
        scheduleModel: {
          plannedRigMoveStartDate: this.dailyReport.scheduleModel.plannedRigMoveStartDate === "" ? null : this.dailyReport.scheduleModel.plannedRigMoveStartDate,
          plannedRigMoveEndDate: this.dailyReport.scheduleModel.plannedRigMoveEndDate === "" ? null : this.dailyReport.scheduleModel.plannedRigMoveEndDate,
          plannedRigMoveDays: this.dailyReport.scheduleModel.plannedRigMoveDays,
          plannedOperationsDays: this.dailyReport.scheduleModel.plannedOperationsDays,
          actualRigMoveDays: this.dailyReport.scheduleModel.actualRigMoveDays,
          rigMoveStartDate: this.dailyReport.scheduleModel.rigMoveStartDate === "" ? null : this.dailyReport.scheduleModel.rigMoveStartDate,
          rigMoveEndDate: this.dailyReport.scheduleModel.rigMoveEndDate === "" ? null : this.dailyReport.scheduleModel.rigMoveEndDate,
          spudDate: this.dailyReport.scheduleModel.spudDate === "" ? null : this.dailyReport.scheduleModel.spudDate,
          spudTime: this.convertTimeStringToDate(this.dailyReport.scheduleModel.spudTime) || "06:00",
          daysOnLocation: this.dailyReport.scheduleModel.daysOnLocation,
          daysFromSpud: this.dailyReport.scheduleModel.daysFromSpud,
          operatingDaysVariance: this.dailyReport.scheduleModel.operatingDaysVariance,        
        },
        aFESummaryModel: {
          code: this.dailyReport.aFESummaryModel.code || "",
          amount: this.dailyReport.aFESummaryModel.amount,
          supplementaryCode: this.dailyReport.aFESummaryModel.supplementaryCode || "",
          actualBudgetRatio: this.dailyReport.aFESummaryModel.actualBudgetRatio,
          supplementaryBudgetRatio: this.dailyReport.aFESummaryModel.supplementaryBudgetRatio,
          supplementaryAmount: this.dailyReport.aFESummaryModel.supplementaryAmount,
          dailyCost: this.dailyReport.aFESummaryModel.dailyCost,
          isAmount: this.dailyReport.aFESummaryModel.isAmount,
        },
        personnelContactsLog: this.dailyReport.personnelContactsLog.map(
          (personnelContact: any) => ({
            id:personnelContact.id,
            position: personnelContact.position,
            contactName: personnelContact.contactName,
            company: personnelContact.company,
            email: personnelContact.email,
            office: personnelContact.office,
            mobile: personnelContact.mobile,
          })
        ),
        personnelOnBoardLog: this.dailyReport.personnelOnBoardLog.map(
          (personnelOnBoards: any) => ({
            id:personnelOnBoards.id,
            company: personnelOnBoards.company,
            serviceType: personnelOnBoards.serviceType,
            workHour: personnelOnBoards.workHour,
            standByHour: personnelOnBoards.standByHour,
            count: personnelOnBoards.count,
            note: personnelOnBoards.note,
          })
        ),
        deviationSurveyData: this.dailyReport.deviationSurveyData.map(
          (deviationSurvey: any) => ({
            id:deviationSurvey.id,
            mD:deviationSurvey.mD,
            inclinationAngle: deviationSurvey.inclinationAngle,
            azimuth: deviationSurvey.azimuth,
            tVD: deviationSurvey.tVD,
            verticalSection: deviationSurvey.verticalSection,
            nS: deviationSurvey.nS,
            eW: deviationSurvey.eW,
            dLS: deviationSurvey.dLS,
          })
        ),
        safetyModel: {
          lastBOPDrill: this.dailyReport.safetyModel.lastBOPDrill,
          nextBOPTest: this.dailyReport.safetyModel.nextBOPTest,
          lastSafetyMeeting: this.dailyReport.safetyModel.lastSafetyMeeting,
          lastFireDrill: this.dailyReport.safetyModel.lastFireDrill,
          lastBOPTest: this.dailyReport.safetyModel.lastBOPTest,
          LastCsgPresTest: this.dailyReport.safetyModel.lastCsgPres,
        },
        mudLosses: {
          shaker: this.dailyReport.mudLosses.volLostShakerSurf,
          pitRoom: this.dailyReport.mudLosses.volLostPitsSurf,
          cleaningEquipment:this.dailyReport.mudLosses.volLostMudCleanerSurf,
          tripping: this.dailyReport.mudLosses.volLostTrippingSurf,
          otherSurface: this.dailyReport.mudLosses.volLostOtherSurf,
          circulating: this.dailyReport.mudLosses.volLostCircHole,
          runningCasing: this.dailyReport.mudLosses.volLostCsgHole,
          cementing: this.dailyReport.mudLosses.volLostCmtHole,
          behindCasing: this.dailyReport.mudLosses.volLostBhdCsgHole,
          abandonment: this.dailyReport.mudLosses.volLostAbandonHole,
          otherLocation: this.dailyReport.mudLosses.volLostOtherHole,
        },
        mudVolume: {
          startVolume: this.dailyReport.mudVolume.volTotMudStart,
          mudDumped: this.dailyReport.mudVolume.volMudDumped,
          mudReceived:this.dailyReport.mudVolume.volMudReceived,
          mudReturned: this.dailyReport.mudVolume.volMudReturned,
          mudBuilt: this.dailyReport.mudVolume.volMudBuilt,
          mudWithinActiveString: this.dailyReport.mudVolume.volMudString,
          mudContainedInCasing: this.dailyReport.mudVolume.volMudCasing,
          mudInOpenAnnulus: this.dailyReport.mudVolume.volMudHole,
          mudInRiserSection:this.dailyReport.mudVolume.volMudRiser,
        },
        drillingParametersModel: {
          torque: this.dailyReport.drillingParametersModel.torque,
          depth: this.dailyReport.drillingParametersModel.depth,
          puWeight: this.dailyReport.drillingParametersModel.puWeight,
          soWeight: this.dailyReport.drillingParametersModel.soWeight,
          maxOPull: this.dailyReport.drillingParametersModel.maxOPull,
          rotatingWeight: this.dailyReport.drillingParametersModel.rotatingWeight,
        },
        bitModel: {
          bha: this.dailyReport.bitModel.bha,
          bitSize: this.dailyReport.bitModel.bitSize,
          modelNo: this.dailyReport.bitModel.modelNo,
          bitType: this.dailyReport.bitModel.bitType,
          iadcNo: this.dailyReport.bitModel.iadcNo,
          serialNo: this.dailyReport.bitModel.serialNo,
          bitHours: this.dailyReport.bitModel.bitHours,
          bitNozzless: this.dailyReport.bitModel.bitNozzless,
          tfa: this.dailyReport.bitModel.tfa,
          impact: this.dailyReport.bitModel.impact,
          jetVelocity: this.dailyReport.bitModel.jetVelocity,
          rpm: this.dailyReport.bitModel.rpm,
          bitRevolution: this.dailyReport.bitModel.bitRevolution,
          bitRotationHours: this.dailyReport.bitModel.bitRotationHours,
          wob: this.dailyReport.bitModel.wob,
        }
      };
      HTTP.put("ddr/update", dailyReport)
        .then((response: any) => {
          this.busy = "SUCCESS";
          this.$store.commit("DailyReportModule/updateEditedDailyReport", {
            dailyReport: response.data.data,
            projectId: this.projectId,
          });
          this.$store.dispatch(
            "DailyReportModule/getReportsForProject",
            this.projectId
          );
          setTimeout(() => {
            this.busy = "NONE";
          }, 3000);
        })
        .catch((error: any) => {
            this.busy = "NONE";            
        });
    }

    convertTimeStringToDate(timeString: string) {
      let [hr, min] = timeString.split(":");
      let hours = parseInt(hr, 10);
      let minutes = parseInt(min, 10);
      let today = new Date();
      
      // Create a new date in UTC and set the hours and minutes as UTC
      let utcDate = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), hours, minutes, 0, 0));
      
      return utcDate;
    }

     @Watch('editedReport',{ immediate:true})onPropertyChanged(value: string, oldValue: string) {
       if(this.editedReport){
          this.setDailyReportProperties();
       }
    }
    get isEditingReport(){
      if(this.isEditingDailyReport == false){
       this.reInitDailyReport();
      }
      return this.isEditingDailyReport;
    }
  
    saveReport() {
      this.busy = "LOADING";
      let dailyReport = {
        startDepth: this.dailyReport.startDepth,
        endDepth: this.dailyReport.endDepth,
        depthReference: this.dailyReport.depthReference,
        depthReferenceType: this.dailyReport.depthReferenceType,
        unitSystem: this.currentUnitSystem,
        startTime: this.dailyReport && this.dailyReport.activityLog && this.dailyReport.activityLog[0] ? this.convertTimeStringToDate(this.dailyReport.activityLog[0].from) : this.convertTimeStringToDate(this.dailyReport.startTime),
        endTime: this.dailyReport && this.dailyReport.activityLog && this.dailyReport.activityLog[this.dailyReport.activityLog.length - 1] ? this.convertTimeStringToDate(this.dailyReport.activityLog[this.dailyReport.activityLog.length - 1].to) : this.convertTimeStringToDate(this.dailyReport.endTime),
        selectedViews: this.dailyReport.selectedViews,
        reportDate: this.dailyReport.reportDate,
        projectId: this.projectId,
        dailySummary: this.dailyReport.dailySummary,
        currentStatus: this.dailyReport.currentStatus,
        dailyForecast: this.dailyReport.dailyForecast,
        dailyChallenge: this.dailyReport.dailyChallenge,
        cost: {budgetLines:this.dailyReport.cost.budgetLines.map((b:any) => ({lineValue:b.lineValue,lineItemId:b.lineItemId,activityId:b.activityId}))},
        projectCost: {
          budgetLines: this.dailyReport.projectCost && this.dailyReport.projectCost.budgetLines && this.dailyReport.projectCost.budgetLines.length ? this.dailyReport.projectCost.budgetLines.map((b:any) => ({
            lineValue: b.lineValue,
            lineItemId: b.lineItemId,
            projectId: b.projectId
          })) : []
        },
        dailyTotalCost: this.dailyReport.dailyTotalCost,
        lumpedCosts: this.dailyReport.lumpedCosts.map((sum:any) => ({
          activityId: sum.activityId,
          departmentId: sum.departmentId,
          operationUnitId: sum.operationUnitId,
          lineValue: sum.lineValue,
        })),
        targets: this.dailyReport.targets ? this.dailyReport.targets.map((target: any) => ({
          id: target.id,
          reservoirName: target.reservoirName,
          fluidType: target.fluidType,
          actualRate: target.actualRate
        })) : [],
        activityLog: this.dailyReport.activityLog.map((logEntry: any) => ({
          from: this.convertTimeStringToDate(logEntry.from),
          to: this.convertTimeStringToDate(logEntry.to),
          hasNpt: logEntry.hasNpt,
          activityInProjectId: logEntry.activity.id,
          activityId: logEntry.milestone && logEntry.milestone.id ? logEntry.milestone.id : -1,
          description: logEntry.description,
          depth: logEntry.depth,
          nptCategory:logEntry.hasNpt? logEntry.nptCategory:"",
          rootCause:logEntry.hasNpt? logEntry.rootCause:"",
          contractor: logEntry.contractor ? logEntry.contractor : "",
          service: logEntry.service ? logEntry.service : "",
          npt:{
            nptDescription:logEntry.hasNpt? logEntry.nptDescription:"",
            nptHours: logEntry.hasNpt && logEntry.nptHours ? logEntry.nptHours : "0",
            nptOperationId: logEntry.hasNpt ? String(this.nptSettings.find((npt: any) => npt.nptCategory === logEntry.nptCategory).id)  : "",
          }
        })),
        mud: {
          mudType: this.dailyReport.mud.mudType,
          mudWeight: this.dailyReport.mud.mudWeight,
          funnelViscosity: this.dailyReport.mud.funnelViscosity,
          plasticViscosity: this.dailyReport.mud.plasticViscosity,
          yieldPoint: this.dailyReport.mud.yieldPoint,
          gelStrength: this.dailyReport.mud.gelStrength,
          htHp: this.dailyReport.mud.hTHP,
          cake: this.dailyReport.mud.cake,
          solids: this.dailyReport.mud.solids,
          eCD: this.dailyReport.mud.eCD,
          pitTemp: this.dailyReport.mud.pitTemp,
          dailyMudCost: this.dailyReport.mud.dailyMudCost,
        },
        depthSummaryModel: {
          currentHoleSize: this.dailyReport.depthSummaryModel.currentHoleSize,
          currentDepth: this.dailyReport.depthSummaryModel.currentDepth,
          actualTotalDepth: this.dailyReport.depthSummaryModel.actualTotalDepth,
          casingSize: this.dailyReport.depthSummaryModel.casingSize,
          casingDepth: this.dailyReport.depthSummaryModel.casingDepth,
          casingType: this.dailyReport.depthSummaryModel.casingType,
          topOfLiner: this.dailyReport.depthSummaryModel.topOfLiner,
          lot: this.dailyReport.depthSummaryModel.lot,
          fit: this.dailyReport.depthSummaryModel.fit,
        },
        scheduleModel: {
          plannedRigMoveStartDate: this.dailyReport.scheduleModel.plannedRigMoveStartDate,
          plannedRigMoveEndDate: this.dailyReport.scheduleModel.plannedRigMoveEndDate,
          plannedRigMoveDays: this.dailyReport.scheduleModel.plannedRigMoveDays,
          plannedOperationsDays: this.dailyReport.scheduleModel.plannedOperationsDays,
          actualRigMoveDays: this.dailyReport.scheduleModel.actualRigMoveDays,
          rigMoveStartDate: this.dailyReport.scheduleModel.rigMoveStartDate === "" ? null : this.dailyReport.scheduleModel.rigMoveStartDate,
          rigMoveEndDate: this.dailyReport.scheduleModel.rigMoveEndDate === "" ? null : this.dailyReport.scheduleModel.rigMoveEndDate,
          spudDate: this.dailyReport.scheduleModel.spudDate === "" ? null : this.dailyReport.scheduleModel.spudDate,
          spudTime: this.convertTimeStringToDate(this.dailyReport.scheduleModel.spudTime),
          daysOnLocation: this.dailyReport.scheduleModel.daysOnLocation,
          daysFromSpud: this.dailyReport.scheduleModel.daysFromSpud,
          operatingDaysVariance: this.dailyReport.scheduleModel.operatingDaysVariance,
        },
        aFESummaryModel: {
          code: this.dailyReport.aFESummaryModel.code,
          amount: this.dailyReport.aFESummaryModel.amount,
          supplementaryCode: this.dailyReport.aFESummaryModel.supplementaryCode,
          supplementaryBudgetRatio: this.dailyReport.aFESummaryModel.supplementaryBudgetRatio,
          actualBudgetRatio: this.dailyReport.aFESummaryModel.actualBudgetRatio,
          supplementaryAmount: this.dailyReport.aFESummaryModel.supplementaryAmount,
          dailyCost: this.dailyReport.aFESummaryModel.dailyCost,
          isAmount: this.dailyReport.aFESummaryModel.isAmount,
        },
        timeBreakDown: {
          circulation: this.dailyReport.timeBreakDown.circulation,
          rIH: this.dailyReport.timeBreakDown.rIH,
          pOOH: this.dailyReport.timeBreakDown.pOOH,
          drilling: this.dailyReport.timeBreakDown.drilling,
          cementing: this.dailyReport.timeBreakDown.cementing,
          tCP: this.dailyReport.timeBreakDown.tCP,
          others: this.dailyReport.timeBreakDown.others,
        },
        personnelContactsLog: this.dailyReport.personnelContactsLog.map(
          (personnelContact: any) => ({
            position: personnelContact.position,
            contactName: personnelContact.contactName,
            company: personnelContact.company,
            email: personnelContact.email,
            office: personnelContact.office,
            mobile: personnelContact.mobile,
          })
        ),
        personnelOnBoardLog: this.dailyReport.personnelOnBoardLog.map(
          (personnelOnBoards: any) => ({
            id:personnelOnBoards.id,
            company: personnelOnBoards.company,
            serviceType: personnelOnBoards.serviceType,
            workHour: personnelOnBoards.workHour,
            standByHour: personnelOnBoards.standByHour,
            count: personnelOnBoards.count,
            note: personnelOnBoards.note,
          })
        ),
        deviationSurveyData: this.dailyReport.deviationSurveyData.map(
          (deviationSurvey: any) => ({
            mD:deviationSurvey.mD,
            inclinationAngle: deviationSurvey.inclinationAngle,
            azimuth: deviationSurvey.azimuth,
            tVD: deviationSurvey.tVD,
            verticalSection: deviationSurvey.verticalSection,
            nS: deviationSurvey.nS,
            eW: deviationSurvey.eW,
            dLS: deviationSurvey.dLS,
          })
        ),
        safetyModel: {
          lastBOPDrill: this.dailyReport.safetyModel.lastBOPDrill,
          nextBOPTest: this.dailyReport.safetyModel.nextBOPTest,
          lastSafetyMeeting: this.dailyReport.safetyModel.lastSafetyMeeting,
          lastFireDrill: this.dailyReport.safetyModel.lastFireDrill,
          lastBOPTest: this.dailyReport.safetyModel.lastBOPTest,
          lastCsgPresTest: this.dailyReport.safetyModel.lastCsgPres,
        },
        mudLosses: {
          shaker: this.dailyReport.mudLosses.volLostShakerSurf,
          pitRoom: this.dailyReport.mudLosses.volLostPitsSurf,
          cleaningEquipment:this.dailyReport.mudLosses.volLostMudCleanerSurf,
          tripping: this.dailyReport.mudLosses.volLostTrippingSurf,
          otherSurface: this.dailyReport.mudLosses.volLostOtherSurf,
          circulating: this.dailyReport.mudLosses.volLostCircHole,
          runningCasing: this.dailyReport.mudLosses.volLostCsgHole,
          cementing: this.dailyReport.mudLosses.volLostCmtHole,
          behindCasing: this.dailyReport.mudLosses.volLostBhdCsgHole,
          abandonment: this.dailyReport.mudLosses.volLostAbandonHole,
          otherLocation: this.dailyReport.mudLosses.volLostOtherHole,
        },
        mudVolume: {
          startVolume: this.dailyReport.mudVolume.volTotMudStart,
          mudDumped: this.dailyReport.mudVolume.volMudDumped,
          mudReceived:this.dailyReport.mudVolume.volMudReceived,
          mudReturned: this.dailyReport.mudVolume.volMudReturned,
          mudBuilt: this.dailyReport.mudVolume.volMudBuilt,
          mudWithinActiveString: this.dailyReport.mudVolume.volMudString,
          mudContainedInCasing: this.dailyReport.mudVolume.volMudCasing,
          mudInOpenAnnulus: this.dailyReport.mudVolume.volMudHole,
          mudInRiserSection:this.dailyReport.mudVolume.volMudRiser,
        },
        drillingParametersModel: {
          torque: this.dailyReport.drillingParametersModel.torque,
          depth: this.dailyReport.drillingParametersModel.depth,
          puWeight: this.dailyReport.drillingParametersModel.puWeight,
          soWeight: this.dailyReport.drillingParametersModel.soWeight,
          maxOPull: this.dailyReport.drillingParametersModel.maxOPull,
          rotatingWeight: this.dailyReport.drillingParametersModel.rotatingWeight,
        },
        bitModel: {
          bha: this.dailyReport.bitModel.bha,
          bitSize: this.dailyReport.bitModel.bitSize,
          modelNo: this.dailyReport.bitModel.modelNo,
          bitType: this.dailyReport.bitModel.bitType,
          iadcNo: this.dailyReport.bitModel.iadcNo,
          serialNo: this.dailyReport.bitModel.serialNo,
          bitHours: this.dailyReport.bitModel.bitHours,
          bitNozzless: this.dailyReport.bitModel.bitNozzless,
          tfa: this.dailyReport.bitModel.tfa,
          impact: this.dailyReport.bitModel.impact,
          jetVelocity: this.dailyReport.bitModel.jetVelocity,
          rpm: this.dailyReport.bitModel.rpm,
          bitRevolution: this.dailyReport.bitModel.bitRevolution,
          bitRotationHours: this.dailyReport.bitModel.bitRotationHours,
          wob: this.dailyReport.bitModel.wob,
        },
      };
      HTTP.post("ddr/create", dailyReport)
        .then((response: any) => {
          this.busy = "SUCCESS";
          this.$store.commit("DailyReportModule/addDailyReport", {
            dailyReport: response.data.data,
            projectId: this.projectId,
          });
          this.reInitDailyReport();
          setTimeout(() => {
            this.busy = "NONE";
          }, 3000);
          this.$emit("submitted", true);
        })
        .catch((error: any) => {
            this.busy = "NONE";            
            this.$emit("submitted", false);
        });
    }
  
    get convertDailyReportToDailyReportModel() {
      return this.$store.getters[
        "DailyReportModule/convertDailyReportToDailyReportModel"
      ](this.dailyReport.id);
    }
  
    getDaysDifference(day1: any, day2: any) {
      const date1 = new Date(day1);
      const date2 = new Date(day2);
      const utcDate1 = Date.UTC(date1.getUTCFullYear(), date1.getUTCMonth(), date1.getUTCDate());
      const utcDate2 = Date.UTC(date2.getUTCFullYear(), date2.getUTCMonth(), date2.getUTCDate());

      const diffTime = Math.abs(utcDate2 - utcDate1);
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      
      return diffDays;
    }
  
    removeActivityLog(index: any) {
      this.dailyReport.activityLog.splice(index, 1);
    }
  
    onLineValueChanged(budgetUpdate: any) {
      if (!this.dailyReport.budgetChanged) this.dailyReport.budgetChanged = true;
  
      let budgetLineIndex = this.dailyReport.cost.budgetLines.findIndex(
        (thisBudgetLine: any) =>
          thisBudgetLine.lineItemId == budgetUpdate.lineItemId &&
          thisBudgetLine.activityId == budgetUpdate.columnId
      );
      //where the budget line index is not found, do a push into budget lines
      if (budgetLineIndex < 0) {
        this.dailyReport.cost.budgetLines.push({
          lineValue:Number(budgetUpdate.value),
          lineItemId: Number(budgetUpdate.lineItemId),
          activityId: Number(budgetUpdate.columnId),
        });
      } else {
        //where the budget line is found, do an update of that particular budget line
        this.dailyReport.cost.budgetLines[budgetLineIndex].lineValue =Number(budgetUpdate.value);
      }
    }

    onValueChanged(budgetUpdate: any) {
      if (!this.dailyReport.budgetChanged) this.dailyReport.budgetChanged = true;
  
      let budgetLineIndex = this.dailyReport.cost.budgetLines.findIndex(
        (thisBudgetLine: any) =>
          thisBudgetLine.lineItemId == budgetUpdate.id &&
          thisBudgetLine.activityId == budgetUpdate.activityId
      );
      //where the budget line index is not found, do a push into budget lines
      if (budgetLineIndex < 0) {
        this.dailyReport.cost.budgetLines.push({
          lineValue: Number(budgetUpdate.dailyCost),
          lineItemId: Number(budgetUpdate.id),
          activityId: Number(budgetUpdate.activityId),
        });
      } else {
        //where the budget line is found, do an update of that particular budget line
        this.dailyReport.cost.budgetLines[budgetLineIndex].lineValue = Number(budgetUpdate.dailyCost);
      }
    }

    onLumpSumValueChanged(budgetUpdate: any) {
      let budgetLineIndex = this.dailyReport.lumpedCosts.findIndex(
        (thisBudgetLine: any) =>
          String(thisBudgetLine.departmentId) === String(budgetUpdate.departmentId) &&
          String(thisBudgetLine.activityId) === String(budgetUpdate.activityId)
          && String(thisBudgetLine.operationUnitId) === String(budgetUpdate.operationUnitId)
      );

      if (budgetLineIndex < 0) {
        this.dailyReport.lumpedCosts.push({
          lineValue:Number(budgetUpdate.lineValue),
          departmentId: budgetUpdate.departmentId,
          operationUnitId: budgetUpdate.operationUnitId,
          activityId: budgetUpdate.activityId,
        });
      } else {
        this.dailyReport.lumpedCosts[budgetLineIndex].lineValue =Number(budgetUpdate.lineValue);
      }
    }

    onProjectCostValueChanged(data: any) {
      let dailyCostLineIndex = this.dailyReport.projectCost ? this.dailyReport.projectCost.budgetLines.findIndex(
        (thisBudgetLine: any) =>
          thisBudgetLine.lineItemId == data.itemId
      ) : -1;

      if (dailyCostLineIndex < 0) {
        if (this.dailyReport.projectCost === null) {
          const dailyCost = {
            budgetTemplateId: Number(data.budgetTemplateId),
            budgetLines: [] as Array<any>,
            projectId: Number(this.selectedProject.id),
          };
          this.dailyReport.projectCost = dailyCost;            
        }
        this.dailyReport.projectCost.budgetLines.push({
          lineValue: Number(data.dailyCost),
          lineItemId: Number(data.itemId),
          lineItemName: data.lineItem,
          sectionName: data.sectionName,
        });
      } else {
        this.dailyReport.projectCost.budgetLines[dailyCostLineIndex].lineValue = Number(data.dailyCost);        
      }
    }
      
    get currentUnitSystem(){
        return this.$store.getters['UnitsModule/getCurrentUnitSystem']
    }
  
  
    get ddrs(): Array<any> {
      return this.$store.getters["DailyReportModule/getReportsForProject"](this.projectId);
    }
  
    get lastDdr() {
      return this.ddrs[this.ddrs.length-1]
    }

    mounted() {      
      this.$emit("submitted", false);
      if (this.nptSettings.length < 1) {
        this.fetchNptSettings;
      }
      if (this.settingswellFluid.length < 1)
            this.fetchColorSettings.then(() => {});
    }
  
    private number = 0
    activated() {      
      this.$emit("submitted", false);
      this.activeView = 'General';
      this.$store.dispatch(
          "DailyReportModule/getReportsForProject",
          this.selectedProject.id
      ).then(res => {
          this.number = res.data.data.length+1
      })
      if (this.getDepartmentOptions.length < 1)
        this.$store.dispatch('departmentModule/getDepartments')
      if (this.$store.state.budgetTemplateModule.budgetTemplates.length < 1)
        this.$store.dispatch("budgetTemplateModule/fetchBudgetTemplates");
      if (this.nptOperations.length < 1)
        this.$store.dispatch("nptModule/fetchNptOperation");
      if (this.contractorAndServicesOptions.length < 1)
        this.$store.dispatch("settingsModule/getContractorAndServices");
      this.$store.dispatch("DailyReportModule/getReportsForProject", this.projectId)
      if (!this.isEdit) {
        this.dailyReport.scheduleModel.plannedRigMoveStartDate = this.rigMove?this.rigMove.start:null
        this.dailyReport.depthSummaryModel.totalDepth= this.selectedProject.well.normDepth ? this.selectedProject.well.normDepth.value : 0
        this.dailyReport.scheduleModel.plannedOperationsDays = this.drilling?this.getDaysDifference(this.drilling.start, this.drilling.end): 0
        this.dailyReport.scheduleModel.plannedRigMoveEndDate = this.rigMove?this.rigMove.end:null
        this.dailyReport.scheduleModel.plannedRigMoveDays = this.rigMove?this.getDaysDifference(this.dailyReport.scheduleModel.plannedRigMoveStartDate, this.dailyReport.scheduleModel.plannedRigMoveEndDate): 0
        this.dailyReport.depthSummaryModel.previousDepth = this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.currentDepth : 0
        this.dailyReport.depthSummaryModel.lot = this.lastDdr && this.lastDdr.depthSummary ? this.lastDdr.depthSummary.lot : 0
        this.dailyReport.scheduleModel.plannedOperationsDays = this.getDaysDifference(this.selectedProject.start, this.selectedProject.end)
        this.dailyReport.bitModel.bha = this.lastDdr && this.lastDdr.bit ? this.lastDdr.bit.bha : 0
        this.dailyReport.bitModel.bitType = this.lastDdr && this.lastDdr.bit ? this.lastDdr.bit.bitType:0
        this.dailyReport.bitModel.modelNo = this.lastDdr && this.lastDdr.bit ? this.lastDdr.bit.modelNo:0
        this.dailyReport.bitModel.iadcNo = this.lastDdr && this.lastDdr.bit ? this.lastDdr.bit.iadcNo:0
        this.dailyReport.bitModel.serialNo = this.lastDdr && this.lastDdr.bit ? this.lastDdr.bit.serialNo:0
        this.dailyReport.mud.prevMudCost = this.lastDdr && this.lastDdr.mud ? Number(this.lastDdr.mud.dailyMudCost) : 0
        this.dailyReport.scheduleModel.daysOnLocation =  this.rigMove?this.getDaysDifference(currentDate, this.rigMove.end):0
        this.dailyReport.scheduleModel.daysFromSpud =  this.dailyReport.scheduleModel.spudDate ?this.getDaysDifference(currentDate, this.dailyReport.scheduleModel.spudDate):0
        this.dailyReport.scheduleModel.spudDate =  this.lastDdr && this.lastDdr.schedule ? this.lastDdr.schedule.spudDate : null
        this.dailyReport.scheduleModel.spudTime =  this.lastDdr && this.lastDdr.schedule ? this.lastDdr.schedule.spudTime : null
        this.dailyReport.scheduleModel.operatingDaysVariance =  this.dailyReport.scheduleModel.plannedOperationsDays- this.dailyReport.scheduleModel.daysFromSpud
        this.dailyReport.aFESummaryModel.cummulativeCost = this.lastDdr && this.lastDdr.afeSummary ? this.dailyReport.aFESummaryModel.dailyCost + this.lastDdr.afeSummary.dailyCost : this.dailyReport.aFESummaryModel.dailyCost
        this.dailyReport.aFESummaryModel.dailyCost = this.lineSum
        this.dailyReport.depthReference = this.lastDdr && this.lastDdr.depthReference ? this.lastDdr.depthReference : null
        this.dailyReport.depthReferenceType = this.lastDdr && this.lastDdr.depthReferenceType ? this.lastDdr.depthReferenceType : null
      }
    }
  }
  